import React, { useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { debounce } from "../../utils/helpers";

const { Search } = Input;

const SearchBar = ({ onSearch, wait = 500, defaultValue = '', placeholder = 'Search here...', allowClear = true, style = {} }) => {

  const onSearchChange  = (e) => {
    onSearch(e.target.value);
  }

  const onSearchCallback = debounce(onSearchChange, wait);

  return (
    <Search
        placeholder={placeholder}
        allowClear={allowClear}
        enterButton={<SearchOutlined />}
        defaultValue={defaultValue}
        onChange={onSearchCallback}
        style={style}
      />
  );
};

export default SearchBar;
